const flagFiles = require.context(".", false, /\.(svg|png|jpe?g)$/);

const normalizeKey = (value) => String(value || "")
  .normalize("NFD")
  .replace(/\p{M}/gu, "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "");

const flagsByKey = flagFiles.keys().reduce((acc, path) => {
  const rawName = path.replace(/^\.\//, "").replace(/\.(svg|png|jpe?g)$/i, "");
  acc[normalizeKey(rawName)] = flagFiles(path);
  return acc;
}, {});

const UF_ALIASES = {
  NACIONAL: ["brasil", "nacional", "br"],
  AC: ["acre", "ac"],
  AL: ["alagoas", "al"],
  AP: ["amapa", "ap"],
  AM: ["amazonas", "am"],
  BA: ["bahia", "ba"],
  CE: ["ceara", "ce"],
  DF: ["distritofederal", "df"],
  ES: ["espiritosanto", "es"],
  GO: ["goias", "go"],
  MA: ["maranhao", "ma"],
  MT: ["matogrosso", "mt"],
  COMPLEMENTAR: ["matogrosso", "mt"],
  MS: ["matogrossosul", "matogrossodosul", "ms"],
  MG: ["minasgerais", "mg"],
  PA: ["para", "pa"],
  PB: ["paraiba", "pb"],
  PR: ["parana", "pr"],
  PE: ["pernambuco", "pe"],
  PI: ["piaui", "pi"],
  RJ: ["riojaneiro", "riodejaneiro", "rj"],
  RN: ["riograndenorte", "riograndedonorte", "rn"],
  RS: ["riograndedosul", "riograndesul", "rs"],
  RO: ["rondonia", "ro"],
  RR: ["roraima", "rr"],
  SC: ["santacatarina", "sc"],
  SP: ["saopaulo", "sp"],
  SE: ["sergipe", "se"],
  TO: ["tocantins", "to"],
};

export const getFlag = (uf, displayName) => {
  const code = String(uf || "").toUpperCase();
  const aliases = [...(UF_ALIASES[code] || [normalizeKey(code)]), displayName].filter(Boolean);

  for (const alias of aliases) {
    const flag = flagsByKey[normalizeKey(alias)];
    if (flag) return flag;
  }

  return null;
};
